<template>
  <div class="form-flow-page">
    <div class="background-overlay"></div>
    <div class="content-wrapper">
      <FormContainer />
    </div>
  </div>
</template>

<script setup>
import FormContainer from '@/components/FormContainer.vue'
</script>

<style scoped>
.form-flow-page {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.content-wrapper {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-flow-page {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .form-flow-page {
    padding: 12px;
  }
}
</style>
